enum StatusCategories {
  PreBooked,
  InProgress,
  Complete,
  Quote,
  ScheduledTemplate,
}

export { StatusCategories }
